import LoanDrilldownCloserViewTab from "../tabs/LoanDrilldownCloserViewTab";
import LoanDrilldownSummaryTab from "../tabs/LoanDrilldownSummaryTab";
import { useLoanSummaryView } from "./useLoanSummaryView";

/**
 * SummaryTabViewRouter — picks the summary layout for the loan drilldown based
 * on the currently selected view (driven by the header's SummaryViewSelector).
 *
 *   default → the standard summary (LoanDrilldownSummaryTab)
 *   closer  → the closing-desk-tailored layout (LoanDrilldownCloserViewTab):
 *             wire amounts, closing files checklist, closing-document tracking,
 *             and a terms/numbers split on the loan-information card.
 *
 * Mounted at the `/` and `/summary` routes in place of the summary tab.
 */
const SummaryTabViewRouter = () => {
  const { view } = useLoanSummaryView();

  if (view === "closer") {
    return <LoanDrilldownCloserViewTab />;
  }

  return <LoanDrilldownSummaryTab />;
};

export default SummaryTabViewRouter;
